"use client"

import { type FC, useState } from "react"
import { Button } from "./button"
import FeedbackDialog from "./FeedbackDialog"
import { toast } from "react-hot-toast"

interface SentryFeedbackButtonProps {
  className?: string
}

const SentryFeedbackButton: FC<SentryFeedbackButtonProps> = ({ className }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const handleOpenDialog = () => {
    setIsDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setIsDialogOpen(false)
  }

  const handleSuccess = () => {
    setIsDialogOpen(false)

    // Show a modern success toast
    toast.custom(
      (t) => (
        <div
          className={`${
            t.visible ? "animate-enter" : "animate-leave"
          } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
        >
          <div className="flex-1 w-0 p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <svg
                  className="h-10 w-10 text-green-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-gray-900">Feedback Submitted</p>
                <p className="mt-1 text-sm text-gray-500">Thank you for your feedback! We appreciate your input.</p>
              </div>
            </div>
          </div>
          <div className="flex border-l border-gray-200">
            <button
              onClick={() => toast.dismiss(t.id)}
              className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-green-600 hover:text-green-500 focus:outline-none"
            >
              Close
            </button>
          </div>
        </div>
      ),
      { duration: 5000 },
    )
  }

  return (
    <>
      <Button
        variant="outline"
        onClick={handleOpenDialog}
        className={`bg-white text-black font-normal text-sm px-4 py-1.5 h-8 rounded border border-gray-200 
          hover:bg-gray-50 transition-colors focus:outline-none shadow-sm ${className}`}
      >
        Feedback
      </Button>

      <FeedbackDialog isOpen={isDialogOpen} onClose={handleCloseDialog} onSuccess={handleSuccess} />
    </>
  )
}

export default SentryFeedbackButton
